// AUTO-GENERATED at every build by scripts/generate-build-info.js. DO NOT EDIT.
export const BUILD_DATE = "03/11/2026 18:47";
export const BUILD_ISO = "2026-11-03T17:47:31.937Z";
export const BUILD_TIMESTAMP = 1793728051937;
